import { render, staticRenderFns } from "./customerMaterial.vue?vue&type=template&id=09c015f5&scoped=true"
import script from "./customerMaterial.vue?vue&type=script&lang=js"
export * from "./customerMaterial.vue?vue&type=script&lang=js"
import style0 from "./customerMaterial.vue?vue&type=style&index=0&id=09c015f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c015f5",
  null
  
)

export default component.exports